var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomRing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 143,
    viewBox: "0 0 155 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2353 224.735C56.2576 224.735 92.7553 188.237 92.7553 143.215C92.7553 98.1926 56.2576 61.6948 11.2353 61.6948C-33.7869 61.6948 -70.2847 98.1926 -70.2847 143.215C-70.2847 188.237 -33.7869 224.735 11.2353 224.735Z",
    stroke: "#C3D3FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9761 244.631C108.994 221.56 135.702 157.446 112.631 101.429C89.56 45.4111 25.4461 18.7027 -30.5714 41.7737C-86.5889 64.8447 -113.297 128.959 -90.2262 184.976C-67.1552 240.994 -3.04136 267.702 52.9761 244.631Z",
    stroke: "#C3D3FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2453 238.825C-41.4747 238.825 -84.3647 195.935 -84.3647 143.215C-84.3647 90.4948 -41.4747 47.6049 11.2453 47.6049C63.9653 47.6049 106.855 90.4948 106.855 143.215C106.845 195.935 63.9553 238.825 11.2453 238.825Z",
    stroke: "#C3D3FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2353 224.735C56.2576 224.735 92.7553 188.237 92.7553 143.215C92.7553 98.1926 56.2576 61.6948 11.2353 61.6948C-33.7869 61.6948 -70.2847 98.1926 -70.2847 143.215C-70.2847 188.237 -33.7869 224.735 11.2353 224.735Z",
    stroke: "#C3D3FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2353 209.615C47.907 209.615 77.6353 179.887 77.6353 143.215C77.6353 106.543 47.907 76.8148 11.2353 76.8148C-25.4364 76.8148 -55.1647 106.543 -55.1647 143.215C-55.1647 179.887 -25.4364 209.615 11.2353 209.615Z",
    stroke: "#C3D3FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2353 195.765C40.2579 195.765 63.7853 172.237 63.7853 143.215C63.7853 114.192 40.2579 90.6648 11.2353 90.6648C-17.7873 90.6648 -41.3147 114.192 -41.3147 143.215C-41.3147 172.237 -17.7873 195.765 11.2353 195.765Z",
    stroke: "#C3D3FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRing);
export default __webpack_public_path__ + "static/media/bottomRing.d144bd26f2ac84cddd9d816d39ced11a.svg";
export { ForwardRef as ReactComponent };